import React from "react";
import { StoreContext } from "../store/RootStore";
import withRouter from "../withRouter";
import { observer } from "mobx-react";
import { Button, Col, Form, Input, Row, Upload, Card, Select, Image, message, Checkbox, Space } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import "./RevenueCollection.css";
import VehicleStore from "../store/VehicleStore";
import config from "../config";
import RevenueCollectionStore from "../store/RevenueCollectionStore";
import dayjs from "dayjs";
import ListTable from "./ListTable";
import DriverBacklogMonitorStore from "../store/DriverBacklogMonitorStore";

const { Option } = Select;

class DriverBacklogMonitor extends React.Component {

    constructor(props, context) {
        super(props);

        this.state = {
            loading: false,
            loadData: 0,
            pageSize: 50,
            currentPage: 1,
            offset: 0,
            limit: 50
        }

        this.columns = [
            {
                title: context.translate("_DRIVER_ID_"),
                dataIndex: "driverId",
                width: 10,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                title: context.translate("_DRIVER_NAME_"),
                dataIndex: "driverName",
                width: 15,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                title: context.translate("_PAYMENT_DEFAULTOR_"),
                dataIndex: "paymentDefaultor",
                width: 15,
                ellipsis: {
                    showTitle: true,
                },
                render: (value) => {
                    return (
                        <Checkbox />
                    )
                }
            },
            {
                // title: "Address",
                title: context.translate("_LAST_PAYMENT_NOT_DONE_DATE_TIME_"),
                dataIndex: "shiftStartTime",
                width: 20,
                ellipsis: {
                    showTitle: true,
                },
            },
            {
                title: context.translate("_LOGOUT_DEFAULTOR_"),
                dataIndex: "logoutDefaultor",
                width: 15,
                ellipsis: {
                    showTitle: true,
                },
                render: (value) => {
                    return (
                        <Checkbox />
                    )
                }
            },
            {
                title: context.translate("_LAST_SHIFT_LOGIN_DATE_TIME_"),
                dataIndex: "shiftEndTime",
                width: 20,
                ellipsis: {
                    showTitle: true,
                },
            },

        ];

        this.handleTableChange = this.handleTableChange.bind(this);
        this.driverBacklogMonitorStore = new DriverBacklogMonitorStore(this)
    }
    async handleTableChange(pagination, filters, sorter) {
        await this.setState({
            currentPage: pagination.current,
            pageSize: pagination.pageSize,
        });
        this.handleSearch();
    }

    async handleSearch() {
        this.setState({ loading: true });
        await this.driverBacklogMonitorStore.getDriverBacklogData({
            offset: (this.state.currentPage - 1) * this.state.pageSize,
            limit: this.state.pageSize,
            // companyId: this.state.companyId,

        });
        await this.setState({ listUpdated: 1 });
    }

    async componentDidMount() {
        await this.handleSearch()
        this.setState({ loadData: 1 })
    }

    render() {
        return (
            <>
                <div className="listHeader">
                    <Row className="listInputRow">
                        <Col span={16}>
                            <Space>
                                <Input
                                    style={{ borderRadius: "40px", width: 250 }}
                                    placeholder={this.context.translate("_NOT_PAYED_SINCE_HOURS_")}
                                />

                                <Input
                                    style={{ borderRadius: "40px", width: 250 }}
                                    placeholder={this.context.translate("_NOT_LOG_OFF_SINCE_")}
                                />

                                <Input
                                    style={{ borderRadius: "40px", width: 250 }}
                                    placeholder={this.context.translate("_SEARCH_DRIVER_")}
                                />

                            </Space>
                        </Col>
                    </Row>
                    <ListTable
                        current={this.state.currentPage}
                        pageSize={this.state.pageSize}
                        total={this.driverBacklogMonitorStore?.total}
                        columns={this.columns}
                        dataSource={this.driverBacklogMonitorStore?.driverBacklogData}
                        loading={this.driverBacklogMonitorStore?.loading}
                        onChange={this.handleTableChange}
                    />
                </div>
            </>)
    }
}

DriverBacklogMonitor.contextType = StoreContext;
export default observer(withRouter(DriverBacklogMonitor));